/** 从localStorage获得marks */
export const getStorageMarks = (storageKey: string): string[] => {
  let marks = [];
  try {
    marks = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (!(marks instanceof Array)) {
      throw new Error('showDates not an Array');
    }
  } catch (e) {
    marks = [];
  }
  return marks;
};

/** 把marks更新到localStorage中 */
export const updateStorageMarks = (storageKey: string, marks: string[]) => {
  localStorage.setItem(storageKey, JSON.stringify(marks));
};


